import Cid10Table from './Cid10Table';

export default Cid10Table;
